import React, { Component } from "react";
import PropTypes from "prop-types";
import { has, get } from "lodash";
import { TabsContainer, Tabs, Tab } from "react-md/lib/Tabs";
import Profile from "./Profile";
import AddIssue from "./AddIssue";
import IssueList from "./IssueList";
import { CustomerShape } from "../../../common/proptypes";

class EditCustomer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTabIndex: 0,
      newReleases: [],
      topTracks: [],
      artists: [],
      visible: false
    };

    this.setTabsContainer = this.setTabsContainer.bind(this);
    this.forceHeightCalculation = this.forceHeightCalculation.bind(this);
  }

  componentDidMount() {
    const { loadCustomer } = this.props;
    if (has(this.props, ["match", "params", "customerId"])) {
      loadCustomer(this.props.match.params.customerId);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { loadCustomer } = this.props;

    //load customer based on customerId in url
    const customerId = get(this.props, ["match", "params", "customerId"]);
    const nextCustomerId = get(nextProps, ["match", "params", "customerId"]);

    if ((!customerId && nextCustomerId) || customerId !== nextCustomerId) {
      loadCustomer(nextCustomerId);
    }
  }

  setTabsContainer(tabsContainer) {
    this.tabsContainer = tabsContainer;
  }

  forceHeightCalculation() {
    if (this.tabsContainer) {
      this.tabsContainer.forceUpdate();
    }
  }

  render() {
    const { className } = this.props;
    const customerKey = get(this.props, ["match", "params", "customerId"], null);
    const customer = this.props.customer
      ? {
          ...this.props.customer,
          key: customerKey
        }
      : null;

    return customer
      ? <div className={className}>
          <div className="md-cell md-cell--12">
            <h5 className="md-headline">Summary</h5>
          </div>
          <div className="md-cell md-cell--12">
            <TabsContainer
              panelClassName="md-grid md-grid--no-spacing"
              ref={this.setTabsContainer}
            >
              <Tabs tabId="phone-stuffs">
                <Tab label="Profile">
                  <Profile
                    customer={customer}
                    className="md-cell md-cell--12"
                    onUpdateUI={this.forceHeightCalculation}
                  />
                </Tab>
                <Tab label="Issues">
                  <AddIssue
                    customer={customer}
                    className="md-cell md-cell--12"
                  />
                  <IssueList
                    customer={customer}
                    className="md-cell md-cell--12"
                    onUpdateUI={this.forceHeightCalculation}
                  />
                </Tab>
              </Tabs>
            </TabsContainer>
          </div>
        </div>
      : null;
  }
}

EditCustomer.propTypes = {
  customer: CustomerShape,
  className: PropTypes.string
};

EditCustomer.defaultProps = {
  customer: {},
  className: null
};

export default EditCustomer;



// WEBPACK FOOTER //
// ./src/customer/components/EditCustomer/EditCustomer.jsx